// Monarch application routing
export enum AppPath {
	AdminRewards = '/admin/rewards',
	Home = '/',
	Index = '/',
	NotFound = '/404',
	Reward = '/rewards/{id}',
	Bonus = '/bonuses/:id',
	Rewards = '/rewards',
}

// Monolith application routing
export enum Route {
	AdminBilling = '/company/billing',
	AdminBillingActivity = '/company/billing_activity',
	AdminEarnings = '/company/accounts',
	AdminRecognition = '/company/reports/bonuses',
	AdminRewards = '/company/rewards?aasm_state=approved&range=all',
	AdminSecurity = '/admin/security/sign_in_logs',
	AdminSettings = '/company/settings/appearance/edit',
	AdminSpend = '/analytics/budget_utilization',
	AdminTotals = '/company/rewards/totals_report',
	AdminUsers = '/company/users',
	Analytics = '/analytics/dashboard',
	Awards = '/claimable_awards',
	Balance = '/company/users/{id}/show_give_balance',
	Billing = '/company/billing',
	Hashtags = '/company/hashtags/{id}',
	History = '/company/accounts/{id}',
	Home = '/bonuses',
	Integrations = '/company/settings/integrations',
	Login = '/users/sign_in_start',
	Logout = '/users/sign_out',
	MyRewards = '/company/rewards/my_rewards',
	PendingAwards = '/awards/approval_requests',
	Rewards = '/company/rewards/new',
	Settings = '/users/edit',
	UserProfile = '/company/users/{id}',
}

// External pages
export enum Page {
	Contact = 'https://bonus.ly/contact',
	Help = 'https://help.bonus.ly/en/',
	NewFeatures = 'https://help.bonus.ly/en/articles/4076250-product-updates-and-new-features',
	PrivacyPolicy = 'https://bonus.ly/privacy_policy',
	Status = 'https://status.bonus.ly/',
	TermsOfService = 'https://bonus.ly/terms_of_service',
	ExtendTrial = 'https://go.bonus.ly/talk-to-a-specialist',
}
